import React, { useContext, useRef, useState } from 'react';
import { Modal, Button, Form, Spinner, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';

import SaveIcon from 'assets/customizeIcons/svg-icons/SaveIcon.js';
import { COLORS } from './Mobile';
import { formatCurrency } from 'pages/comptabilite/utils/functions';
import { journals, sortes } from 'pages/comptabilite/Clients/SingleFacture/PaiementPopup';
import SvgGallery from 'assets/customizeIcons/svg-icons/GalleryIcon';
import { usePlanningData } from './hooks/usePlanningData';
import { deleteAPI, postAPI } from 'apis/backend/apiNode';
import AuthContext from 'contexts/authContext';
import showNotification from 'components/extras/showNotification';
import { paiementAPI, uploadAttachmentAPI } from 'apis/backend/apiPython';

const AddPaiementLineModal = ({ setVisible, setInterventionData, interventionData }) => {
	const [spinner, setSpinner] = useState(false);
	const [error, setError] = useState('');
	const { updateIntervention } = usePlanningData();
	const { userData } = useContext(AuthContext);

	const [uploading, setUploading] = useState(false);
	const [attachments, setattachments] = useState([]);

	const fileInputRef = useRef(null);

	const closeModal = () => setVisible(false);

	// Gestion des fichiers sélectionnés
	const handleFileChange = (e) => {
		const selectedFiles = Array.from(e.target.files || []);
		setattachments((prev) => [...(prev || []), ...selectedFiles]);
		e.target.value = ''; // ✅ permet de re-sélectionner le même fichier
	};

	const deleteAttachment = (idxToRemove) => {
		setattachments((prev) => (prev || []).filter((_, idx) => idx !== idxToRemove));
	};

	// const handleSavePaiement = async (values) => {
	// 	if (!values.montant || parseFloat(values.montant) <= 0) {
	// 		showNotification('Erreur', 'Le montant doit être supérieur à 0', 'warning');
	// 		return;
	// 	}

	// 	setSpinner(true);
	// 	setError('');

	// 	try {
	// 		const montant = parseFloat(values.montant);
	// 		let pythonPaymentId = null;

	// 		// ✅ Sync python (optionnel)
	// 		try {
	// 			const companyId =
	// 				interventionData?.cars?.[0]?.companyId ?? interventionData?.companyId;

	// 			const pythonData = {
	// 				payment_method: values.methode_paiement, // ⚠️ si python attend un ID -> mapping à faire
	// 				amount: montant,
	// 				date_payment: values.date_payment || new Date().toISOString().split('T')[0],
	// 				currency: 'EUR',
	// 				payment_type: 'inbound',
	// 				partner_type: 'customer',
	// 				partner_id: interventionData?.client?._id,
	// 				partner_name: interventionData?.client?.nom,
	// 				company_id: companyId,
	// 				ref_intervention: interventionData?.reference || '',
	// 			};

	// 			const res = await paiementAPI(pythonData);
	// 			pythonPaymentId = res?.id;

	// 			if (pythonPaymentId) {
	// 				showNotification('Succès', 'Paiement comptabilisé', 'success');
	// 			}
	// 		} catch (pythonError) {
	// 			console.error('❌ Python sync error:', pythonError);
	// 			showNotification(
	// 				'Info',
	// 				'Paiement créé localement (Erreur sync compta)',
	// 				'warning',
	// 			);
	// 		}

	// 		const paiementLocalData = {
	// 			montant,
	// 			methode_paiement: values.methode_paiement,
	// 			date_payment: values.date_payment || new Date().toISOString().split('T')[0],
	// 			ref_intervention: interventionData.reference || '',
	// 			statut: 'en_attente',
	// 			currency: 'EUR',
	// 			payment_type: 'inbound',
	// 			payment_id: pythonPaymentId,
	// 			created_at: new Date().toISOString(),
	// 			updatedAt: new Date().toISOString(),
	// 		};

	// 		const fullUpdateData = {
	// 			rapport_intervention: {
	// 				...(interventionData?.rapport_intervention || {}),
	// 				paiements: [
	// 					paiementLocalData,
	// 					...(interventionData?.rapport_intervention?.paiements || []),
	// 				],
	// 			},
	// 			updatedBy: userData?.id,
	// 			performedBy: userData?.id,
	// 		};

	// 		await updateIntervention(interventionData?._id, fullUpdateData);

	// 		// ✅ Upload fichiers si pythonPaymentId existe
	// 		const moduleName = 'paiements';
	// 		if (attachments?.length > 0 && pythonPaymentId) {
	// 			try {
	// 				setUploading(true);

	// 				const formData = new FormData();
	// 				attachments.forEach((file) => formData.append('files', file));
	// 				formData.append('module', moduleName);
	// 				formData.append('record_id', pythonPaymentId);

	// 				await uploadAttachmentAPI(formData);
	// 			} catch (uploadError) {
	// 				console.error('❌ Upload error:', uploadError);
	// 				setError("Échec de l'upload des fichiers.");
	// 			} finally {
	// 				setUploading(false);
	// 			}
	// 		}

	// 		// ✅ Update local UI state
	// 		setInterventionData((prev) => ({
	// 			...prev,
	// 			rapport_intervention: {
	// 				...(prev?.rapport_intervention || {}),
	// 				paiements: [
	// 					paiementLocalData,
	// 					...(prev?.rapport_intervention?.paiements || []),
	// 				],
	// 			},
	// 		}));

	// 		// ✅ Reset + close only on success
	// 		setattachments([]);
	// 		closeModal();
	// 	} catch (err) {
	// 		console.error('❌ Error saving payment:', err);
	// 		setError('Erreur lors de la sauvegarde');
	// 		showNotification(
	// 			'Erreur',
	// 			err?.message || 'Erreur inattendue lors de la sauvegarde',
	// 			'danger',
	// 		);
	// 	} finally {
	// 		setSpinner(false);
	// 	}
	// };


	const handleSavePaiement = async (values) => {
		if (!values.montant || parseFloat(values.montant) <= 0) {
			showNotification('Erreur', 'Le montant doit être supérieur à 0', 'warning');
			return;
		}

		setSpinner(true);
		setError('');

		try {
			const montant = parseFloat(values.montant);
			let pythonPaymentId = null;

			// 1. ✅ Sync with Python Backend
			try {
				const companyId = interventionData?.companyId?._id || interventionData?.cars?.[0]?.companyId;

				const pythonData = {
					payment_method: values.methode_paiement,
					amount: montant,
					date_payment: values.date_payment || new Date().toISOString().split('T')[0],
					currency: 'EUR',
					payment_type: 'inbound',
					partner_type: 'customer',
					partner_id: interventionData?.client?._id,
					partner_name: interventionData?.client?.nom,
					company_id: companyId,
					ref_intervention: interventionData?.reference || '',
					created_by: userData?.id,
					sorte: values?.sorte || sortes[0]
				};

				const res = await paiementAPI(pythonData);
				pythonPaymentId = res?.id;

				// if (pythonPaymentId) {
				// 	showNotification('Succès', 'Paiement comptabilisé', 'success');
				// }
			} catch (pythonError) {
				console.error('❌ Python sync error:', pythonError);
				showNotification(
					'Info',
					'Paiement créé localement (Erreur sync compta)',
					'warning',
				);
			}



			// Prepare unique IDs list for paiement_ids
			const existingIds = interventionData?.rapport_intervention?.paiement_ids || [];
			const updatedIdsList = pythonPaymentId
				? [...new Set([pythonPaymentId, ...existingIds])]
				: existingIds;

			const fullUpdateData = {
				rapport_intervention: {
					...(interventionData?.rapport_intervention || {}),
					// Update the new list of strings (IDs)
					paiement_ids: updatedIdsList
				},
				updatedBy: userData?.id,
				performedBy: userData?.id,
			};

			// 3. ✅ Update MongoDB
			await updateIntervention(interventionData?._id, fullUpdateData);

			// 4. ✅ Upload Files if Python ID exists
			if (attachments?.length > 0 && pythonPaymentId) {
				try {
					setUploading(true);
					const formData = new FormData();
					attachments.forEach((file) => formData.append('files', file));
					formData.append('module', 'paiements');
					formData.append('record_id', pythonPaymentId);

					await uploadAttachmentAPI(formData);

					// If you have a local map for attachments, refresh it here

				} catch (uploadError) {
					console.error('❌ Upload error:', uploadError);
					setError("Échec de l'upload des fichiers.");
				} finally {
					setUploading(false);
				}
			}

			// 5. ✅ Update local UI state
			setInterventionData((prev) => ({
				...prev,
				rapport_intervention: {
					...(prev?.rapport_intervention || {}),
					paiement_ids: updatedIdsList
				},
			}));

			// Reset and close
			setattachments([]);
			closeModal();
		} catch (err) {
			console.error('❌ Error saving payment:', err);
			setError('Erreur lors de la sauvegarde');
			showNotification(
				'Erreur',
				err?.message || 'Erreur inattendue lors de la sauvegarde',
				'danger',
			);
		} finally {
			setSpinner(false);
		}
	};
	return (
		<Modal show={true} onHide={() => { }} fullscreen>
			<Modal.Header
				closeButton
				className='bg-white border-bottom pt-4 pb-3 d-flex justify-content-between align-items-start'
				onHide={closeModal}></Modal.Header>

			<Modal.Body className='p-0'>
				{/* ===== HEADER ===== */}

				{/* ===== BODY ===== */}
				<div
					style={{
						padding: 20,
						maxWidth: 600,
						margin: '0 auto',
					}}>
					<Formik
						enableReinitialize
						initialValues={{
							montant: '',
							methode_paiement: journals?.[0] ?? '',
							sorte: sortes?.[0] ?? '',
							reference: '',
							statut: 'en_attente',
							notes: '',
							date_payment: new Date().toISOString().split('T')[0],
						}}
						onSubmit={(values) => handleSavePaiement(values)}>
						{({ handleChange, values, setFieldValue, handleSubmit }) => (
							<Form onSubmit={handleSubmit}>
								<h4
									style={{
										textAlign: 'center',
										marginBottom: 20,
										color: '#172B4D',
									}}>
									Nouveau paiement
								</h4>

								{/* ===== Méthode de paiement ===== */}
								<Form.Group style={{ marginBottom: 20 }}>
									<Form.Label>Méthode de paiement *</Form.Label>

									<div className='d-flex gap-3 flex-column'>
										{(journals || []).map((item) => (
											<Button
												key={item}
												type='button'
												className='w-100'
												variant={
													values.methode_paiement === item
														? 'primary'
														: 'light'
												}
												onClick={() =>
													setFieldValue('methode_paiement', item)
												}>
												{item}
											</Button>
										))}
									</div>
								</Form.Group>

								<Form.Group style={{ marginBottom: 20 }}>
									<Form.Label>Type *</Form.Label>

									<div className='d-flex gap-3 flex-column'>
										{(sortes || []).map((item) => (
											<Button
												key={item}
												type='button'
												className='w-100'
												variant={
													values.sorte === item
														? 'primary'
														: 'light'
												}
												onClick={() =>
													setFieldValue('sorte', item)
												}>
												{item}
											</Button>
										))}
									</div>
								</Form.Group>

								{/* ===== Montant ===== */}
								<Form.Group style={{ marginBottom: 15 }}>
									<Form.Label>Montant</Form.Label>
									<Form.Control
										type='number'
										name='montant'
										placeholder='0'
										value={values.montant}
										onChange={handleChange}
										style={{
											backgroundColor: '#ebebeb',
											borderRadius: 12,
											border: 'none',
										}}
									/>
								</Form.Group>

								<hr style={{ backgroundColor: '#ebebeb' }} />

								{/* ===== Pièces jointes ===== */}
								<div>
									<h6
										style={{
											fontWeight: 600,
											color: '#172B4D',
											marginBottom: 10,
										}}>
										Pièces jointes{' '}
										<small className='text-muted fw-normal ms-2'>
											(images, vidéos, PDF…)
										</small>
									</h6>

									<Button
										type='button'
										className='my-4 w-100'
										disabled={uploading}
										onClick={() => fileInputRef.current?.click()}
										style={{
											backgroundColor: COLORS.BG_L10_PRIMARY,
											height: 70,
											borderRadius: 10,
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											justifyContent: 'center',
											gap: 6,
											border: 'none',
											cursor: uploading ? 'not-allowed' : 'pointer',
										}}>
										{uploading ? (
											<Spinner
												animation='border'
												size='sm'
												style={{ color: COLORS.PRIMARY }}
											/>
										) : (
											<SvgGallery size={30} color={COLORS.PRIMARY} />
										)}

										<span
											style={{
												fontSize: 12,
												fontWeight: 600,
												color: COLORS.PRIMARY,
											}}>
											{uploading ? 'Upload...' : 'Ajouter images'}
										</span>

										<input
											ref={fileInputRef}
											type='file'
											multiple
											onChange={handleFileChange}
											style={{ display: 'none' }}
										/>
									</Button>

									{attachments?.length > 0 && (
										<Row className='g-3'>
											{attachments.map((file, idx) => {
												const isUrl = typeof file === 'string';
												const previewUrl = isUrl
													? file
													: URL.createObjectURL(file);

												return (
													<Col
														key={idx}
														xs={12}
														sm={6}
														md={4}
														lg={3}
														xl={2}>
														<div
															style={{
																position: 'relative',
																border: '1px solid #e7e7e7',
																borderRadius: 10,
																overflow: 'hidden',
																background: '#fafafa',
															}}>
															<button
																type='button'
																onClick={() => {
																	// cleanup objectURL for File
																	if (!isUrl)
																		URL.revokeObjectURL(
																			previewUrl,
																		);
																	deleteAttachment(idx);
																}}
																style={{
																	position: 'absolute',
																	top: 8,
																	right: 8,
																	zIndex: 10,
																	border: 'none',
																	background: 'rgba(0,0,0,0.6)',
																	color: '#fff',
																	borderRadius: '50%',
																	width: 28,
																	height: 28,
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	cursor: 'pointer',
																}}>
																×
															</button>

															<a
																href={previewUrl}
																download={
																	isUrl
																		? undefined
																		: file?.name ||
																		`attachment-${idx}`
																}
																style={{
																	textDecoration: 'none',
																	color: 'inherit',
																}}>
																<div
																	style={{
																		height: 190,
																		display: 'flex',
																		alignItems: 'center',
																		justifyContent: 'center',
																		backgroundColor: '#f5f5f5',
																	}}>
																	<img
																		src={previewUrl}
																		alt={`attachment-${idx}`}
																		style={{
																			width: '100%',
																			height: '100%',
																			objectFit: 'contain',
																		}}
																	/>
																</div>
															</a>
														</div>
													</Col>
												);
											})}
										</Row>
									)}
								</div>

								{/* ===== SAVE ===== */}
								<Button
									type='submit'
									disabled={spinner}
									style={{
										width: '100%',
										height: 44,
										borderRadius: 10,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										gap: 10,
										backgroundColor: '#6c5dd3',
										border: 'none',
									}}>
									<SaveIcon size={20} color={COLORS.WHITE} />
									<span>Enregistrer</span>
								</Button>
							</Form>
						)}
					</Formik>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default AddPaiementLineModal;
